<template>
  <div>
    <template v-if="errorCheck">
      <span class="text-red-500 font-semibold">JU JENI VLERESUAR</span>
    </template>
    <template v-else>
      <form @submit.prevent="addRatings">
        <div class="flex">
          <div class="flex mb-4 p-4">
            <label class="block text-gray-700 px-2 text-sm font-bold mb-2" for="username">M1 - 0</label>
            <input type="radio" class="mt-1" name="m1" value="0" v-model="m1" />
            <label class="block text-gray-700 px-2 text-sm font-bold mb-2" for="username">M1 - +</label>
            <input type="radio" class="mt-1" name="m1" value="+" v-model="m1" />
            <label class="block text-gray-700 px-2 text-sm font-bold mb-2" for="username">M1 - M</label>
            <input type="radio" class="mt-1" name="m1" value="M" v-model="m1" />
          </div>
          <div class="flex mb-4 p-4">
            <label class="block text-gray-700 px-2 text-sm font-bold mb-2" for="username">BZ - 0</label>
            <input type="radio" class="mt-1" value="0" v-model="bz" />
            <label class="block text-gray-700 text-sm px-2 font-bold mb-2" for="username">BZ - +</label>
            <input type="radio" class="mt-1" value="+" v-model="bz" />
            <label class="block text-gray-700 text-sm px-2 font-bold mb-2" for="username">BZ - M</label>
            <input type="radio" class="mt-1" value="M" v-model="bz" />
          </div>
          <div class="flex mb-4 p-4">
            <label class="block text-gray-700 text-sm px-2 font-bold mb-2" for="username">M3 - 0</label>
            <input type="radio" class="mt-1" value="0" v-model="m3" />
            <label class="block text-gray-700 text-sm px-2 font-bold mb-2" for="username">M3 - +</label>
            <input type="radio" class="mt-1" value="+" v-model="m3" />
            <label class="block text-gray-700 text-sm px-2 font-bold mb-2" for="username">M3 - M</label>
            <input type="radio" class="mt-1" value="M" v-model="m3" />
          </div>
        </div>
        <div class="flex">
          <div class="mb-4 p-4" v-if="m1 == '0' || m1 == 'M'">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="username">COMMENT M1</label>
            <textarea
              class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              v-model="comment_m1"
              :required="m1 == '0' || m1 == 'M'"
            ></textarea>
          </div>
          <div class="mb-4 p-4" v-if="bz == '0' || bz == 'M'">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="username">COMMENT BZ</label>
            <textarea
              class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              v-model="comment_bz"
              :required="bz == '0' || bz == 'M'"
            ></textarea>
          </div>
          <div class="mb-4 p-4" v-if="m3 == '0' || m3 == 'M'">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="username">COMMENT M3</label>
            <textarea
              class="shadow appearance-none border rounded w-auto py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              v-model="comment_m3"
              :required="m3 == '0' || m3 == 'M'"
            ></textarea>
          </div>
          <div class="mb-4 pt-12">
            <div v-if="error">
              <span class="text-red-600 font-semibold">{{ error }}</span>
            </div>
            <div class="p-1">
              <button
                type="submit"
                class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
              >Shto</button>
            </div>
            <div class="p-1">
              <router-link
                to="/excel#friday"
                class="block uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
              >Kthehu</router-link>
            </div>
          </div>
        </div>
      </form>
    </template>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      m1: "",
      bz: "",
      m3: "",
      comment_m1: "",
      comment_bz: "",
      comment_m3: "",
      day: this.$route.query.date,
      error: "",
      errorCheck: "",
      id: ""
    };
  },
  created() {
    this.getUser();
    this.checkRating();
  },
  methods: {
    addRatings() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      if (this.m1 === "" || this.bz === "" || this.m3 === "") {
        this.error = "Ju lutem plotsoni formen!!";
      } else {
        axios
          .post(
            `${process.env.VUE_APP_API}/excel/vlersimet/create?day=${this.day}`,
            {
              m1: this.m1,
              bz: this.bz,
              m3: this.m3,
              comment_m1: this.comment_m1,
              comment_bz: this.comment_bz,
              comment_m3: this.comment_m3,
              day: this.day
            }
          )
          .then(this.$router.push("/excel"))
          .catch(error => console.log(error));
      }
    },
    getUser() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios.get(`${process.env.VUE_APP_API}/user`).then(response => {
        this.id = response.data.data.id;
      });
    },
    checkRating() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(
          `${process.env.VUE_APP_API}/excel/vlersimet/check?day=${this.day}&user_id=${this.id}`
        )
        .then(response => {
          this.errorCheck = response.data.vleresuar;
        })
        .catch(error => console.log(error));
    }
  }
};
</script>

<style></style>
